export default __webpack_public_path__ + "static/media/cocacola.0ed63a29.png";